import React, { Component } from 'react'
import { bindActionCreators } from 'redux';
import { msToHMS } from '../../../utils/useful';
import { connect } from 'react-redux';
import * as actions from "../../../stores/actionsList";
import { checkTranslation, translate } from "../../../utils/useful";
import Responsive from '../../../components/Responsive';
import ButtonAnimated from '../../../components/buttons/ButtonAnimated';
import CustomLoader from '../../../components/CustomLoader';

let moment = require('moment-timezone');

class UserRecent extends Component {

    openEditModal = (prop, index) => {
        this.itemModal.showModal()
        this.setState({ currentItem: prop, currentIndex: index })

    }

    openRemoveModal = (prop, index) => {
        this.removeModal.modal.showModal()
        this.setState({ currentItem: prop, currentIndex: index })
    }


    state = {
        week: ['mon', 'tu', 'we', 'th', 'fr', 'sa', 'su',],
        days: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,],
        month: { startDay: 0, daysCount: 30 },
        monthFromNow: 0,
        today: '',
        time: ['00', '00', '00'],
    }

    // addClicked = (open) => {
    //     this.itemModal.open()
    // }

    // changeStage = (stage) => {
    //     this.databaseStages.changeStage(stage)
    // }

    // lastStagePage = () => {
    //     this.props.removeWindowLink()
    //     this.databaseStages.lastStage()
    // }

    componentWillMount() {
        this.setState({ title: this.props.data, today: new Date().getTime() })
        if (this.props.data) {
            this.setMonth(0, this.props.data)
        } else {
            this.setMonth(0)
        }
    }

    componentDidMount = () => {
        if (this.props.setHeader) {

            this.props.setHeader({
                'toolbar': null,
                'showToolbar': false,
                // topHeaderComponent: this.topHeaderComponent,
                // backAction: () => this.props.backToQuizPage('start')

            })
        }
        this.props.changeBackbtn()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data != this.props.data) {
            this.setMonth(0, this.props.data)
            this.setState({ title: this.props.data })
        }
    }

    changeMonth(number) {
        this.setMonth(this.state.monthFromNow + number)
        this.setState({ monthFromNow: this.state.monthFromNow + number })
    }

    setMonth(fromNow, startDate) {
        let now = new Date();
        let days = []
        let start = moment(now).add(fromNow, 'month').startOf('month')
        if (startDate) {
            start = moment(startDate).add(fromNow, 'month').startOf('month')
        }
        for (let i = 0; i < moment(now).add(fromNow, 'month').daysInMonth(); i++) {
            days.push({ start: moment(start).add(i, 'day').startOf('day').valueOf(), end: moment(start).add(i, 'day').endOf('day').valueOf() })
        }
        this.setState({ month: { title: moment(start).format('YYYY-MMMM'), startDay: start.day(), days: days } })
    }

    setDay(day) {
        let startOrEnd = this.props.startOrEnd ? this.props.startOrEnd : "start"
        if (!this.props.startOrEnd && this.props.header.information?.startOrEnd) {
            startOrEnd = this.props.header.information.startOrEnd
        }
        this.setState({ title: day[startOrEnd] })
    }

    showDays() {
        let week = []
        let weeks = []
        let days = []
        let startDay = this.state.month.startDay
        let count = 0
        startDay = startDay === 0 ? 7 : startDay
        for (let i = 0; i < startDay - 1; i++) {
            days.push(null)
        }
        days = [...days, ...this.state.month.days]
        for (let i = 0; i < days.length; i++) {
            count++
            week.push(days[i])
            if (count == 7 || i == days.length - 1) {
                weeks.push(week)
                count = 0
                week = []
            }
        }
        let lastWeekLenght = weeks[weeks.length - 1].length
        if (lastWeekLenght < 7) {
            for (let i = 0; i < 7 - lastWeekLenght; i++) {

                weeks[weeks.length - 1].push(null)
            }
        }
        count = 0
        return weeks.map((week, index) => {
            return (
                <div key={index} className="d-flex text-center pld-2 prd-2 w-100 " style={{ justifyContent: 'space-between' }}>
                    {week.map((day, index1) => {
                        if (day == null) {
                            return (
                                <div key={index1} style={{ width: '100%', padding: 10, width: 35 }}>
                                </div>
                            )
                        } else {
                            count++
                            let isToday = (this.state.today >= day.start && this.state.today <= day.end) ? true : false
                            let selectedDay = (this.state.title >= day.start && this.state.title <= day.end) ? true : false
                            let available = true
                            if (this.props.endDate && day.start > this.props.endDate) {
                                available = false
                            }
                            if (this.props.startDate && day.end < this.props.startDate) {
                                available = false
                            }
                            return (
                                <div onClick={() => { if (available) this.setDay(day); this.stageManager.changeStage('time') }} key={index1} style={{ cursor: 'pointer', width: '100%', backgroundColor: selectedDay ? '#34C759' : '', padding: 0, borderRadius: 40, width: 35, height: 35, justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                                    <div style={{ backgroundColor: isToday ? '#f5f5f5' : 'transparent', borderRadius: 40, padding: 0, minWidth: 30, height: 30, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <span style={{ color: available ? (selectedDay ? '#fff' : '#345') : '#abc', fontSize: 12 }}>{count}</span>
                                    </div>
                                </div>
                            )
                        }
                    })}
                </div>
            )
        })
    }

    changeView = () => {
        this.setState({ viewMode: !this.state.viewMode })
    }

    changeQuizPage = (changeUrl, changeStage) => {
        this.props.changeQuizPage(changeUrl)
        this.props.changePage(changeStage)
    }

    render() {
        return (
            <div className='scroll-no-scrollbar h-100 '>
                <div className=''>
                    <div className='w-100 d-flex flex-column  '>
                        {/* <div className={this.state.incomingExam ? 'flexc' : 'flexcc'}>
                            {this.state.incomingExam && (
                                <Responsive width={this.props.width} media={{ xs: "none", sm: '6', md: '5', lg: "4", xl: "4" }}>
                                    <div className='pld-5 prd-2' style={{ height: '270px' }}>
                                        <div className='br-10 modern-input1 with-shadow d-flex flexcc px-3 py-3 cursor-pointer' style={{ justifyContent: 'flex-start', alignItems: 'flex-start', border: '1px solid #eee', height: '270px' }}>
                                            <div className='flexcc flex-column'>
                                                <div className='' style={{ justifyContent: 'left' }}>
                                                    <div className='flexc'>
                                                        <p className='font-size-12 color-black' style={{}}>{translate('Quiz name')}:&nbsp;</p>
                                                        <p className='font-size-12 color-black' style={{}}>Math exam</p>
                                                    </div>
                                                    <div className='flexc'>
                                                        <p className='font-size-12 color-black' style={{}}>{translate('Teacher')}&nbsp;</p>
                                                        <p className='font-size-12 color-black' style={{}}>Mr.Brown</p>
                                                    </div>
                                                    <div className='flexc'>
                                                        <p className='font-size-12 color-black' style={{}}>{translate('Duration')}:&nbsp;</p>
                                                        <p className='font-size-12 color-black' style={{}}>2Hours</p>
                                                    </div>
                                                    <div className='flexc'>
                                                        <p className='font-size-12 color-black' style={{}}>{translate('Opening at')}&nbsp;</p>
                                                        <p className='font-size-12 color-black' style={{}}>28 Nov 10:00</p>
                                                    </div>
                                                    <div className='flexc'>
                                                        <p className='font-size-12 color-black' style={{}}>{translate('Closing at')}&nbsp;</p>
                                                        <p className='font-size-12 color-black' style={{}}>30 Nov 17:00</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Responsive>
                            )}
                            <Responsive width={this.props.width} media={{ xs: "12", sm: '12', md: '12', lg: "12", xl: "12" }}>
                                <div className='w-100' style={{}}>
                                    <div className="text-start flexcc w-100 py-3 prd-5 pld-3 pt-3" style={{ display: 'flex', zIndex: 5, }}>
                                        <div className={'search-drop-down '} style={{ direction: 'ltr', paddingBottom: 10, paddingTop: 10, display: 'flex', flexDirection: 'column', width: '100%', backgroundColor: '#ffffff', borderRadius: 8, boxShadow: '0px 0px 30px rgba(0,0,0,0.1)', border: '1px solid #eee' }}>
                                            <div className="d-flex flexc p-2" style={{ justifyContent: 'space-between' }}>
                                                <img className="rotate-180" onClick={() => this.changeMonth(-1)} src="/images/nexts.png" height="14px" />
                                                <p style={{ color: '#222' }}>{checkTranslation(this.state.month.title)}</p>
                                                <img className="" onClick={() => this.changeMonth(1)} src="/images/nexts.png" height="14px" />
                                            </div>
                                            <div className="d-flex p-2 text-center w-100" style={{ justifyContent: 'space-between' }}>
                                                {this.state.week.map((prop, index) => {
                                                    return (
                                                        <div className={'w-100'} style={{ width: 35, }}>
                                                            <p style={{ color: '#789', fontSize: 12 }}>{checkTranslation(prop)}</p>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                            <div className='px-4 mx-3'>
                                                <div className=''>
                                                    {this.showDays()}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Responsive>
                        </div> */}
                        <div className='flexcb w-100 px-2 mx-2 pt-2 mt-2'>
                            <p className='font-size-18 text-semibold main-c3'>{translate("Available Inquiries")}</p>
                            <button className='mx-3 hover-gray p-1 br-5' onClick={() => this.changeView()}>
                                <img className='flexcc' width={24} src={!this.state.viewMode ? '/assets/icons/note/listview.svg' : '/assets/icons/note/tableview.svg'} />
                            </button>
                        </div>
                        {/* {console.log('this.props.data0pp0',this.props.data)} */}
                        {this.props.data ?
                            !this.state.viewMode ? (
                                <div className='d-flex flex-wrap m-2'>
                                    {Array.isArray(this.props.data) && this.props.data.length > 0 ?
                                        (this.props.data.map((item, index) => {
                                            let duration = item.values?.duration
                                            if (Array.isArray(duration) && duration.length > 0) {
                                                duration = duration[0] + ':' + duration[1] + ':' + duration[2]
                                            }
                                            // console.log('itemmmmm', item.values.public)
                                            return (
                                                <Responsive width={this.props.width} className="mb-3" media={{ xs: '12', 530: '6', 770: '4', 1000: '3', 1500: '2' }}>
                                                    <div className='bg-white shadow-2 p-3 br-10 m-2 h-100' style={{}}>
                                                        {/* <p className=''>{checkTranslation(item.status)}</p> */}
                                                        <div className='w-100 h-100'>
                                                            <div className='flexcc flex-column h-100'>
                                                                {/* <div>
                                                                    <img className='br-50' width={80} src='/images/p4.png' />
                                                                </div> */}
                                                                <div className='d-flex flex-column pt-2 w-100'>
                                                                    <p className='font-size-16 weight-500'>{checkTranslation(item?.values?.title)}</p>

                                                                    <p className='text-smaller mt-2'>{checkTranslation(item?.values?.description)}</p>

                                                                    {/* <p className='weight-500 font-size-16 flexcc' style={{ color: '#96C723' }}>{checkTranslation(item?.values?.score)}</p> */}
                                                                    {/* <p className='weight-500 font-size-16 flexcc pt-1' style={{ color: '#96C723' }}>86/100</p> */}
                                                                    <div className='pt-2  flex-column w-100' style={{}}>
                                                                        {duration?.length > 0 &&
                                                                            <div className='flexc'>
                                                                                <p className='font-size-12 color-gray-2' style={{}}>{translate('Duration')}&nbsp;</p>
                                                                                <p className='font-size-12 color-gray-2' style={{}}>{(duration.split(':').slice(1).filter((e) => e != "undefined").join(':'))}</p>
                                                                            </div>
                                                                        }
                                                                        {item?.values?.date &&
                                                                            <div className='flexc'>
                                                                                {/* <p className='font-size-12 color-gray-2' style={{}}>{translate("Opening at")}&nbsp;</p> */}
                                                                                <p className='font-size-12 color-gray-2' style={{}}>{moment(item?.values?.date).format("DD,  MMM, YYYY (HH:mm)")}</p>
                                                                            </div>
                                                                        }
                                                                        {item?.values?.expiryDate &&
                                                                            <div className='flexc'>
                                                                                <p className='font-size-12 color-gray-2' style={{}}>{translate('Closing at')}&nbsp;</p>
                                                                                <p className='font-size-12 color-gray-2' style={{}}>{moment(item?.values?.expiryDate).format("DD,  MMM, YYYY (HH:mm)")}</p>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>

                                                                <div style={{ flex: 1 }}></div>
                                                                <div className='flexcc flex-column mt-3 mb-3 w-100'>
                                                                    <ButtonAnimated
                                                                        onClick={() => this.changeQuizPage(['quiz', item._id], ['startQuiz'])}
                                                                        icon={'/assets/icons/arrow-right-white.svg'}
                                                                        bg={this.props.colors?.background ? this.props.colors.background : 'linear-gradient(90deg, #6E9318, #96C723)'}
                                                                        title={'View Inquery'}
                                                                        width={'100%'} />
                                                                    {/* <div className='pt-2'>
                                                                        <ButtonAnimated
                                                                            onClick={() => this.changeQuizPage(['quiz', item._id], ['startQuiz'])}
                                                                            title={checkTranslation('More')}
                                                                            textColor={this.props.colors?.primaryColor ? this.props.colors.primaryColor : '#222'}
                                                                            // invert={!this.props.colors?.iconInvert}
                                                                            bg={'linear-gradient(90deg, #ffffff, #ffffff)'}
                                                                            width={'100%'}
                                                                            className=" inquiry-btn-border w-100 br-30 py-2 mt-2 "

                                                                        />
                                                                    </div> */}
                                                                    {/* <ButtonAnimated icon={'/assets/icons/arrow-right-white.svg'} bg={'linear-gradient(90deg, #ffffff, #ffffff)'} title={'More'} width={'100%'} /> */}
                                                                    {/* <button className='inquiry-btn-border w-100 br-30 py-2 mt-2'>
                                                                <p>{translate('More')}</p>
                                                            </button> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Responsive>
                                            )
                                        })) : (
                                            <div className='h-100 w-100 flexcc pt-5'>
                                                <p>{translate('There is no inquiries.')}</p>
                                            </div>
                                        )
                                    }
                                </div>
                            ) : (
                                <div className='d-flex flex-wrap m-2'>
                                    {Array.isArray(this.props.data) && this.props.data.length > 0 ?
                                        (this.props.data.map((item, index) => {
                                            return (
                                                <Responsive width={this.props.width} media={{ xs: '12', 500: '6', 700: '6', 1000: '4', 1500: '4' }}>
                                                    <div className='bg-white shadow-2 p-3 br-10 m-2' onClick={() => this.changeQuizPage(['quiz', item._id], ['startQuiz'])}>
                                                        {/* <p className=''>{checkTranslation(item.status)}</p> */}
                                                        <div className='w-100'>
                                                            <div className='flexc'>
                                                                <div>
                                                                    <img className='br-50' width={80} src='/images/p4.png' />
                                                                </div>
                                                                <div className='d-flex flex-column mld-3 text-start w-100'>
                                                                    <p className='text-start font-size-16 weight-500'>{checkTranslation(item?.values?.title)}</p>
                                                                    <p className='weight-500 font-size-16' style={{ color: '#96C723' }}>86/100</p>
                                                                    <div className='pt-2'>
                                                                        {item?.values?.duration &&
                                                                            <div className='flexc text-start'>
                                                                                <p className='font-size-12 color-gray-2' style={{}}>{translate('Duration')}&nbsp;</p>
                                                                                <p className='font-size-12 color-gray-2' style={{}}>{msToHMS(item?.values?.duration)}</p>
                                                                            </div>
                                                                        }
                                                                        {item?.values?.date &&
                                                                            <div className='flexc text-start'>
                                                                                <p className='font-size-12 color-gray-2' style={{}}>{translate("Opening at")}&nbsp;</p>
                                                                                <p className='font-size-12 color-gray-2' style={{}}>{moment(item?.values?.date).format("DD,  MMM, YYYY (HH:mm)")}</p>
                                                                            </div>
                                                                        }
                                                                        {item?.values?.expiryDate &&
                                                                            <div className='flexc text-start'>
                                                                                <p className='font-size-12 color-gray-2' style={{}}>{translate('Closing at')}&nbsp;</p>
                                                                                <p className='font-size-12 color-gray-2' style={{}}>{moment(item?.values?.expiryDate).format("DD,  MMM, YYYY (HH:mm)")}</p>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='flexc mt-3 w-100' style={{ justifyContent: 'flex-end' }} >
                                                                <div className='prd-4'>
                                                                    <ButtonAnimated
                                                                        title={checkTranslation('More')}
                                                                        textColor={this.props.colors?.primaryColor ? this.props.colors.primaryColor : '#222'}
                                                                        // invert={!this.props.colors?.iconInvert}
                                                                        bg={'linear-gradient(90deg, #ffffff, #ffffff)'}
                                                                        className=" inquiry-btn-border w-100 br-30 py-2 mt-2 "
                                                                    />
                                                                </div>
                                                                {/* <button className='inquiry-btn-border2 br-30 mrd-4' style={{ width: '120px', height: '40px' }}>
                                                            <p>more</p>
                                                        </button> */}
                                                                <ButtonAnimated icon={'/assets/icons/arrow-right-white.svg'} bg={this.props.colors?.background ? this.props.colors.background : 'linear-gradient(90deg, #6E9318, #96C723)'} title={'Start'} />
                                                                {/* <button className='inquiry-btn br-30 py-2 mld-2' style={{ width: '120px' }}>
                                                            <p>Start</p>
                                                        </button> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Responsive>
                                            )
                                        })) : (
                                            <div className='h-100 w-100 flexcc pt-5'>
                                                <p>{translate('There is no inquiries.')}</p>
                                            </div>
                                        )
                                    }
                                </div>
                            ) :
                            <div className='flexcc w-100 h-100 pt-5' style={{ width: '28px', }}>
                                <CustomLoader color={this.props.colors ? this.props.colors.primaryColor : '#eee'} isLoading={true} width={27} type={"Oval"} className={'flexcc'} />
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }








}




const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserRecent);
